import { useEffect } from "react";
import { Card } from "@mui/material";
import { useSelector } from "react-redux";

const GoogleReviewsWidget = () => {
  const appId = useSelector((state) => state.fetchUser?.user?.googlereviewID);

  useEffect(() => {
    const scriptUrl = "https://static.elfsight.com/platform/platform.js";
    if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  if (!appId) return null;

  return (
    <Card
      style={{
        padding: "10px",
        borderRadius: "15px",
        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        className="widget-container"
        style={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        <div
          className={appId}
          data-elfsight-app-lazy
          style={{
            transform: "scale(1)",
            transformOrigin: "center",
            width: "100%",
            height: "100%",
          }}
        ></div>
      </div>
    </Card>
  );
};

export default GoogleReviewsWidget;
